import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { FC } from 'react';
import { useOrdering } from '../../../stores/OrderingStore';
import OrderDetail from './OrderDetail';
import { LayoutVariant } from '../../Core/CommonTypes';

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(1),
    display: 'flex'
  },
  wrapper: {
    flex: 1
  },
  title: {
    marginRight: 48
  },
  close: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1)
  }
}));

interface OrderDetailDialogProps {
  onClose?: () => void;
  onSubmit?: () => void;
}

const OrderDetailDialog: FC<OrderDetailDialogProps> = ({
  onClose,
  onSubmit
}) => {
  const classes = useStyles();
  const orderingStore = useOrdering();

  return (
    <Dialog open onClose={onClose} fullScreen scroll="paper">
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.title}>
          YOUR ORDER
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.close}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers classes={{ root: classes.content }}>
        <Box className={classes.wrapper}>
          <OrderDetail
            order={orderingStore.order}
            onDeleteItem={item => orderingStore.deleteItem(item)}
            onEditItem={item => orderingStore.editItem(item)}
            onItemChange={item => {
              orderingStore.onOrderItemUpdate(item);
            }}
            promotions={orderingStore.availablePromotions}
            onApplyCheapestPromotion={promotion =>
              orderingStore.applyCheapestPromotion(promotion)
            }
            variant={LayoutVariant.mobile}
          />
        </Box>
      </DialogContent>
      <DialogActions disableSpacing>
        <Button
          onClick={onSubmit}
          color="primary"
          size="large"
          disabled={orderingStore.order.total === 0}
        >
          SUBMIT
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default OrderDetailDialog;
